export default __webpack_public_path__ + "static/media/ge3.286ec6f2.jpg";